<template>
  <div>
    <div class="tbd-content">
      <div class="product-detail">
        <div class="title">
          <img src="@static/images/visitorManage/icon1.png" alt="" />
          产品的访客详情
        </div>
        <div class="title-content">
          <img :src="statisticsInfo.shortMobImg" alt="" />
          <div>
            <p>产品名称<span>{{ statisticsInfo.productName }}</span></p>
            <p>产品编号<span>{{ statisticsInfo.productNo }}</span></p>
          </div>
        </div>
      </div>
      <!-- 搜索部分 -->
      <topSearchForm @search="searchAjax" @export="exportToExcel">
        <el-form :inline="true" class="rform" :model="searchParams" ref="loginform" label-width="100px">

          <el-form-item label="微信昵称">
            <el-input v-model="searchParams.nickname" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input v-model="searchParams.mobile" placeholder="请输入" clearable></el-input>
          </el-form-item>

        </el-form>
      </topSearchForm>

      <ul>
        <li v-for="(item, index) in statistics" :key="index">
          <img :src="item.img" alt="" />
          <div>
            <p>{{ item.value }}</p>
            <span>{{ item.text }}</span>
          </div>
        </li>
      </ul>

      <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading='listLoading'>
        <el-table-column label="序号" width="50px;" type="index" fixed="left"></el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <div>{{ scope.row.mobile }}</div>
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" min-width="200px;" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="wx-name">
              <img v-if="scope.row.imgUrl" :src="scope.row.imgUrl" alt="" />
              <p>{{ scope.row.nickname }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="停留时长" property="totalDuration">
          <template slot-scope="scope">
            {{ scope.row.totalDuration == '00:00:00' ? '-' : scope.row.totalDuration }}
          </template>
        </el-table-column>
        <el-table-column label="用户行为" property="behaviorRecordStr" min-width="200px;" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="退出节点" property="exitBehaviorStr"></el-table-column>
        <el-table-column label="是否成交">
          <template slot-scope="scope">
            <p :class="[{ green: scope.row.isHasPolicy == 1 }, 'red']">{{ scope.row.isHasPolicy == 1 ? '是' : '否' }}</p>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
        :layout="$tools.pageLayout" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
//当前实例组件
import topSearchForm from "@/components/topSearchForm.vue";
import { common, pageTool } from "@/api/mixins";
import dayjs from "dayjs";

export default {
  components: {
    topSearchForm,
  },
  mixins: [common, pageTool],
  data: () => ({
    statistics: [
      {
        text: '总停留时长',
        img: require('@static/images/visitorManage/product-icon1.png'),
        key: 'totalDuration',
        value: '0'
      },
      {
        text: '产品PV (次)',
        img: require('@static/images/visitorManage/product-icon2.png'),
        key: 'productPv',
        value: '0'
      },
      {
        text: '产品UV (人)',
        img: require('@static/images/visitorManage/product-icon3.png'),
        key: 'productUv',
        value: '0'
      },
      {
        text: '成交量',
        img: require('@static/images/visitorManage/product-icon4.png'),
        key: 'policyNum',
        value: '0'
      },
      { 
        text: '成交转化率',
        img: require('@static/images/visitorManage/product-icon5.png'),
        key: 'volRate',
        value: '0%'
      },
    ],
    statisticsInfo: {}
  }),

  created() {
    this.initListAjax("/master/productVisitor/queryProductVisitor");
  },

  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    listCallback(res){
      this.total = Number(res.data.total);
      this.tableData = res.data.records;
      this.statisticsInfo = res.statistics;
      this.statistics.map((item) => {
        item.value = this.statisticsInfo[item.key];
        if(item.key == 'volRate'){
          item.value += '%';
        }
      })
    },
    setListParams(params){
      params.productId = this.$route.query.productId;
    },

    // 导出
    exportToExcel() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$tools.daochu("/master/productVisitor/exportProductVisitor", params, 'PUT');
    },
  },
};
</script>

<style lang="scss" scoped>
.tbd-content {
  background: #ffffff;
  padding: 20px 30px 30px 30px;
  .product-detail{
    margin-top: -10px;
    .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      display: flex;
      align-items: center ;
      img{
        width: 16px;
        margin-right: 4px;
      }
    }
    .title-content{
      display: flex;
      align-items: center;
      height: 110px;
      background: linear-gradient(106deg, #FFF7EA 0%, #FFF1E8 100%);
      border-radius: 4px;
      margin: 16px 0;
      img{
        width: 110px;
        height: 110px;
        margin-right: 25px;
      }
      div{
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        p{
          font-size: 15px;
          color: #86796C;
          span{
            color: #3C1D00;
            margin-left: 20px;
          }
          &:nth-of-type(1){
            margin-bottom: 15px;
          }
        }
      }
    }
  }
  ul{
    display: flex;
    align-items: center;
    margin: 8px 0;
    li{
      display: flex;
      align-items: center;
      width: 310px;
      img{
        width: 50px;
        margin-right: 12px;
      }
      div{
        p{
          font-size: 18px;
          font-weight: 600;
          color: #F47900;
          margin-bottom: 5px;
        }
        span{
          font-size: 14px;
          color: #3C1D00;
        }
      }
    }
  }
  .select-form{
    width: calc(100% - 510px);
    .el-form-item{
      width: 48%;
    }
  }
}

// .el-pagination {
//   margin-top: 50px;
// }

.list-table {
  margin-top: 20px;
  .cell {
    text-align: center;
  }
  .is-left {
    .cell {
      text-align: left;
    }
  }
  .wx-name{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    img{
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    p{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .red{
    width: 24px;
    height: 24px;
    background: rgb(255,241,240);
    border: 1px solid #FEB9B5;
    border-radius: 4px;
    color: #F8585D;
    margin: 0 auto;
  }
  .green{
    background: rgb(246,255,236);
    border: 1px solid #AEEA7F;
    color: #22BC02;
  }
}

</style>